import { Validators } from '@angular/forms';
import hoursRegex from '../../lead-generation/shared/regex/hoursRegex';
import hoursRangeFormValidator from './working-hours-range/hours-range-form.validator';
import daysRangeFormValidator from './working-hours-range/days-range-form.validator';
var hoursValidator = Validators.pattern(hoursRegex);
export var createHoursRange = function (_a, fb) {
    var from = _a.from, to = _a.to;
    return fb.group({
        from: fb.control(from, [hoursValidator, Validators.required]),
        to: fb.control(to, [hoursValidator, Validators.required])
    }, { validator: hoursRangeFormValidator });
};
export var createRange = function (range, fb) {
    var hours = range.hours.map(function (hoursRange) { return createHoursRange(hoursRange, fb); });
    return fb.group({
        hours: fb.array(hours),
        days: fb.array(range.days)
    }, { validator: daysRangeFormValidator });
};
export var createGroup = function (workingHorus, timezone, fb) {
    var ranges = workingHorus.ranges.map(function (range) { return createRange(range, fb); });
    return fb.group({
        enabled: workingHorus.enabled,
        timezone: timezone,
        ranges: fb.array(ranges)
    });
};
